.fieldset {
  border: 0;
  margin-inline: 0;
  padding-block: 0;
  padding-inline: 0;
}

:global(.ant-form legend) {
  margin-bottom: 0;
  border-bottom: 0;
}
